import { render, staticRenderFns } from "./TaskChangeMaterials.vue?vue&type=template&id=21f51518"
import script from "./TaskChangeMaterials.vue?vue&type=script&lang=ts"
export * from "./TaskChangeMaterials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports